import {Fragment} from 'react';

import classes from './SignupHelp.module.scss';

declare function Translate(key: string): string;

const   SignupHelp = () => {
    return(
        <Fragment>
            <div>
                <span className={classes.text}>{Translate('N_Login_SignUp_Help')}</span>&nbsp;
                <span className={classes.text}>{Translate('N_General_Moked')}</span>                               
                <a className={classes.phone} href="tel:1299">1299</a>
            </div>
        </Fragment>
    );    
};
export default SignupHelp;